
import { Download } from 'lucide-react';
import { cn } from '../utils/cn';
import toast from 'react-hot-toast';

interface DownloadButtonProps {
  content: string;
  filename: string;
  mimeType?: string;
  className?: string;
  onDownload?: () => void;
}

export function DownloadButton({
  content,
  filename,
  mimeType = 'text/plain',
  className,
  onDownload,
}: DownloadButtonProps) {
  const handleDownload = () => {
    try {
      const blob = new Blob([content], { type: mimeType });
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = filename;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      URL.revokeObjectURL(url);
      toast.success('Downloaded!');
      onDownload?.();
    } catch (err) {
      toast.error('Failed to download');
    }
  };

  return (
    <button
      onClick={handleDownload}
      className={cn(
        'inline-flex items-center gap-2 px-3 py-1.5 text-sm',
        'bg-surface hover:bg-slate-700 border border-slate-700 rounded-lg',
        'text-slate-300 hover:text-white transition-colors',
        className
      )}
      title="Download file"
    >
      <Download className="w-4 h-4" />
      Download
    </button>
  );
}
